import { API, authClient } from "../index";

export const getOfferStatusHistory = (accessToken) => {
  return authClient(accessToken).get(`${API}/offer-status-history`);
};
